import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/siteData';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Elegant%20packaging%20boxes%20and%20shopping%20bags%20arranged%20artistically%20with%20fashion%20items%20spilling%20out%20on%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20editorial%20luxury%20product%20photography%2C%20minimal%20modern%20aesthetic%2C%20high%20detail%2C%20celebratory%20mood%2C%20no%20text&width=1800&height=600&seq=cta-prod-bg-002&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 to-background-950/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          Ready to Build a Smarter Basetao Shopping Workflow?
        </h2>
        <p className="text-sm md:text-base text-background-200 mb-8 max-w-xl mx-auto leading-relaxed">
          Access complete spreadsheet resources, shipping calculators, and expert guides to transform your international shopping experience.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/basetao-spreadsheet-guide"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all whitespace-nowrap"
          >
            <i className="ri-file-list-3-line mr-2"></i>
            Access Complete Spreadsheet Resources
          </Link>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-950 bg-accent-400 hover:bg-accent-300 rounded-lg transition-all whitespace-nowrap"
          >
            Basetao Spreadsheet
          </a>
        </div>
      </div>
    </section>
  );
}